import React, { useEffect, useRef, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { influencerData } from '../../data/mock';

const FinalCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="contact"
      ref={sectionRef}
      className="relative py-32 md:py-40 bg-[#121212] overflow-hidden"
    >
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] via-transparent to-[#0A0A0A]" />
      
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
      <div className="absolute bottom-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />

      <div className="relative max-w-4xl mx-auto px-6 lg:px-12 text-center">
        {/* Label */}
        <p
          className={`text-[#D4AF37] text-xs tracking-[0.4em] mb-6 transition-all duration-1000 ease-out ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          LET'S CONNECT
        </p>

        {/* Headline */}
        <h2
          className={`font-playfair text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-8 transition-all duration-1000 ease-out ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
          style={{ transitionDelay: '200ms' }}
        >
          Let's Create Something
          <br />
          <span className="italic text-[#D4AF37]">Exceptional</span>
        </h2>

        {/* Description */}
        <p
          className={`text-[#A1A1AA] text-lg max-w-2xl mx-auto mb-12 transition-all duration-1000 ease-out ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
          style={{ transitionDelay: '400ms' }}
        >
          Ready to elevate your brand with content that resonates? 
          I partner exclusively with premium brands seeking meaningful impact.
        </p>

        {/* CTA Button */}
        <div
          className={`transition-all duration-1000 ease-out ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
          style={{ transitionDelay: '600ms' }}
        >
          <a
            href={`mailto:${influencerData.email}`}
            className="group inline-flex items-center gap-3 px-10 py-5 bg-[#D4AF37] text-[#0A0A0A] text-sm tracking-[0.2em] font-medium hover:bg-[#F5D76E] transition-all duration-500 hover:shadow-[0_0_50px_rgba(212,175,55,0.4)] hover:scale-105"
          >
            START A CONVERSATION
            <ArrowRight
              className="group-hover:translate-x-2 transition-transform duration-300"
              size={18}
            />
          </a>
        </div>

        {/* Email */}
        <p
          className={`mt-8 text-[#A1A1AA] text-sm transition-all duration-1000 ease-out ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
          style={{ transitionDelay: '800ms' }}
        >
          Or reach out directly at{' '}
          <a
            href={`mailto:${influencerData.email}`}
            className="text-[#D4AF37] hover:underline"
          >
            {influencerData.email}
          </a>
        </p>
      </div>
    </section>
  );
};

export default FinalCTA;
